<template>
  <div class="serviceDetail">
    <span class="dGoBack" @click="$router.back(-1)"></span>
    <h3>关于我们</h3>
    <p class="dTime">2018-06-23</p>
    <div class="dCon">
      <p>尽情期待</p>
    </div>
  </div>
</template>
<script>
  export default {
    name:'detail',
    data(){
      return{
        tab:0
      }
    },
    methods:{
      showTab(index){
        this.tab=index;
      }
    }
  }
</script>
<style scoped>
  @import url('../service/style/service.css');
  .serviceDetail{
    min-height: 100vh;
    background: #fff;
    padding: 0 15px;
    overflow: hidden;
  }
  .dCon img{
    max-width: 100%;
  }
</style>





// WEBPACK FOOTER //
// src/components/about/about.vue